import { useMutation } from '@tanstack/react-query';
import { clientStripeApi } from '@client/api/waterlily';
import { useToast } from '@/components/hooks/use-toast';

interface UseClientStripeCheckoutSessionOptions {
  clientAuthUserId: string;
  returnPath?: string;
}

export function useClientStripeCheckoutSession({
  clientAuthUserId,
  returnPath,
}: UseClientStripeCheckoutSessionOptions) {
  const { errorToast } = useToast();

  const mutation = useMutation({
    mutationFn: () =>
      clientStripeApi.createCheckoutSession({
        clientAuthUserId,
        returnPath,
        uiMode: 'embedded',
      }),
    onError: (error: unknown) => {
      const errorMessage =
        error instanceof Error
          ? error.message
          : 'An unexpected error occurred. Please try again.';
      errorToast('Checkout Error', errorMessage, 8000);
    },
  });

  return {
    createCheckoutSession: mutation.mutate,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    clientSecret: mutation.data?.clientSecret ?? null,
    amountInCents: mutation.data?.amountInCents ?? null,
    isSelfFundUnlock: mutation.data?.isSelfFundUnlock ?? false,
    reset: mutation.reset,
  };
}
